import BigNumber from "bignumber.js";
import { BASE18 } from "src/configs/constance";
import { handleEmit } from "src/contract-logic/logic";
import { getCurrentContractAddresses } from "src/configs/address";
import ABI from "src/contract-logic/abis/NFTMarketplaceCollectionABI.json";
import { getWeb3Sender, web3Reader } from "src/wallet-connection";

const { NFT_SELL_COLLECTION_ADDRESS } = getCurrentContractAddresses();
var contractReader = null;
var contractSender = null;

function getContractReader() {
  if (!contractReader) {
    contractReader = new web3Reader.eth.Contract(ABI, NFT_SELL_COLLECTION_ADDRESS);
  }
  return contractReader;
}

function getContractSender() {
  const web3Sender = getWeb3Sender();
  if (!contractSender) {
    contractSender = new web3Sender.eth.Contract(ABI, NFT_SELL_COLLECTION_ADDRESS);
  }
  return contractSender;
}

async function makeSaleOrder(dispatch, tokenId, accountAddress) {
  const emit = getContractSender().methods.makeOrder(tokenId).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Buy NFT");
  return await emit;
}

async function getTokenOfOwnerBalance(ownerAddress) {
  const res = await getContractReader().methods.getTokenOfOwnerBalance(ownerAddress).call();
  return parseInt(res);
}

async function getTokenOnSaleCount() {
  const res = await getContractReader().methods.getTokenOnSaleCount().call();
  return parseInt(res);
}

async function getTokenOrder(tokenId) {
  const res = await getContractReader().methods.getTokenOrder(tokenId).call();
  return {
    price: BigNumber(res.price).dividedBy(BASE18).toNumber(),
    seller: res.nftSeller,
  };
}

export default {
  ABI,
  ADDRESS: NFT_SELL_COLLECTION_ADDRESS,
  getTokenOfOwnerBalance,
  getTokenOnSaleCount,
  getTokenOrder,
  makeSaleOrder,
};
